import gql from "graphql-tag";
import getQuery from "./get_query";
import ParcisionCookies from "../../../utils/Cookies";

export default async function encryptContract(
  cid: number,
  estimate1: number,
  estimate2: number,
  estimate3: number,
  description: string
) {
  const address = ParcisionCookies.get("address");
  const variables = {
    cid,
    estimate1,
    estimate2,
    estimate3,
    description,
    address,
  };

  const query = gql`
    query MyQuery(
      $cid: Float!
      $estimate1: String!
      $estimate2: String!
      $estimate3: String!
      $description: String!
      $address: String!
    ) {
      encryptContract(
        cid: $cid
        estimate1: $estimate1
        estimate2: $estimate2
        estimate3: $estimate3
        description: $description
        address: $address
      ) {
        estimate1
        estimate2
        estimate3
        description
      }
    }
  `;

  const data = await getQuery(query, variables);
  // @ts-expect-error
  return data.encryptContract;
}
